import React, { useEffect } from "react";  
 
import Header from 'components/Dashboard/Header'  
  
import { 
    DashboardPage,
    DashboardBody,
    DashboardBodyContent,
    Content
} from "./styled";
import { ReadObject } from "services/storage";
import { useHistory } from "react-router-dom";
import { ThemedComponent } from "ui/theme";
import DashboardSide from "components/Dashboard/Side";

export default function ContainerAuthenticated({ children, page, print }){  

    const history = useHistory();
    const navigate = to => history.push(`/${ to }`);

    const init = () => {
        const authentication = ReadObject('authentication')
        if (!authentication?.jwt) {
            completeNext()
        }
    }
 
    const completeNext = () => {
        navigate('login')
    }

    useEffect(() => {  
        init() 
    }, [])

    return ( 
        <>
            <ThemedComponent>
                <Content>
                    <DashboardPage>
                        { print ? null : <Header /> }
                        <DashboardBody> 
                            { print ? null : <DashboardSide opened={true} page={page} /> }
                            <DashboardBodyContent>                     
                                { children }
                            </DashboardBodyContent>
                        </DashboardBody>  
                    </DashboardPage> 
                </Content>
            </ThemedComponent>
        </>
    );
}